<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="provisioningList"
            :description="false"
            @selected="handleSelected"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("system.label.ProvisionCommand") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push('/createCommand').catch(() => {})"
                  size="small"
                  >{{ $t("system.label.Create") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("system.label.ProvisioningSystem") }}</vs-th>
              <vs-th>{{ $t("system.label.CommandName") }}</vs-th>
              <vs-th>{{ $t("system.label.Status") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("system.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="provisioningList"
                v-for="(provisioningList, index) in data"
              >
                <vs-td :data="provisioningList.provisioningSystemName">{{
                  provisioningList.provisioningSystemName
                }}</vs-td>
                <vs-td :data="provisioningList.commandName">{{
                  provisioningList.commandName
                }}</vs-td>
                <vs-td :data="provisioningList.status">{{
                  provisioningList.status
                }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('system.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editCreateCommand(provisioningList.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('system.label.Delete')"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      class="icon_row"
                      @click.stop="
                        deleteProvisioningPopup = true;
                        delId = provisioningList.id;
                      "
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('system.label.DeleteProvisionCommand')"
          :active.sync="deleteProvisioningPopup"
        >
          <div class="vx-row centerx md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">
                {{ $t("system.label.AreYouSure") }}
              </div>
            </div>
          </div>

          <div class="vx-row centerx">
            <span class="ml-4 mr-1">
              <vs-button
                type="border"
                @click="deleteProvisioningPopup = false"
                >{{ $t("system.label.cancel") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="deleteProvisionData(delId)" color="warning">{{
                $t("system.label.ok")
              }}</vs-button>
            </span>
          </div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      deleteProvisioningPopup: false,
      delId: 0,
    };
  },
  components: {
    AtomSpinner,
  },
  computed: {
    ...mapGetters({
      provisioningList: "provisioningConfig/getcommandList",
    }),
  },
  methods: {
    async getCommandData() {
      this.loading = true;
      try {
        await this.$store.dispatch("provisioningConfig/setprovisioningData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    async deleteProvisionData(id) {
      try {
        await this.$store.dispatch(
          "provisioningConfig/deleteProvisioningCommand",
          id
        );
        this.getCommandData();
        this.deleteProvisioningPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    editCreateCommand(id) {
      this.$router.push(`/editCreateCommand/${id}`);
    },

    handleSelected(provisioningList) {
      this.$router.push({
        path: `/viewProvisioningMapping/${provisioningList.id}`,
      });
    },
  },
  mounted() {
    this.getCommandData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
</style>
